import type { ReactNode } from 'react';

import type { FeatureKey } from '../../../../shared/features';
import { useAuth } from '../../hooks/use-auth';

/** Só gate de UI: quem de fato impede a chamada é o backend (`requireFeature`). */
export function FeatureGate({ feature, children }: { feature: FeatureKey; children: ReactNode }) {
  const { hasFeature } = useAuth();

  if (!hasFeature(feature)) {
    return null;
  }

  return <>{children}</>;
}
